import { AnimatePresence, motion } from 'motion/react';
import { useSelector } from 'react-redux';
import { usePermissions } from '../../hooks/use-permissions';
import { getBrowseMode } from '../../store/uiSlice';
import { getUser } from '../../store/userSlice';
import { Collaborators } from './collaborators/collaborators';
import { GeneralTask } from './general-task/general-task';
import { Help } from './help/help';
import { ShareTask } from './share-task/share-task';

export const Collaboration = () => {
  const { isPermitted } = usePermissions();
  const browseMode = useSelector(getBrowseMode);
  const userData = useSelector(getUser);



  return (
    <div className="flex justify-end gap-1.5 z-10 items-center">
      <AnimatePresence>
        {!browseMode && (
          <>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{
                opacity: 0, x: 50,
                transition: { delay: 0, duration: 0.2 }
              }}
              transition={{ duration: 0.4, delay: 0.75, type: 'spring', stiffness: 300, damping: 16, mass: 0.5 }}
              className="flex gap-2 items-center"
            >
              {userData?.raw && isPermitted("collaborate-bottom-bar-team-member-list") && <Collaborators />}
              {isPermitted("collaborate-bottom-bar-general-task") && <GeneralTask />}
            </motion.div>
          </>
        )}
      </AnimatePresence>
      {userData?.raw?.email && isPermitted("collaborate-bottom-bar-share") && <ShareTask />}
      {isPermitted("collaborate-bottom-bar-tutorial-mode") && <Help />}
    </div>
  );
};
